<mat-form-field class="search-phrases">
  <mat-icon matPrefix>search</mat-icon>
  <mat-icon
    data-cy="clear-phrase-notes-keyword"
    (click)="clearSearchPhrase()"
    class="clear-phrase-search"
    matSuffix
  >clear</mat-icon>
  <mojo-editor
    toolbar=""
    class="notes-search"
    [placeholder]="''"
    [maxLength]="3000"
    [hasAnonymization]="hasAnonymization$ | async"
    [shouldResetOnItemSelectedOrEnterPressed]="true"
    [showCandidateMentionTags]="showMentionTags"
    [showUserMentionTags]="showMentionTags"
    (eventItemSelected)="addSearchItemQuill($event)"
    (eventEnterPressed)="addSearchStringQuill($event)"
  >
  </mojo-editor>
  <input
    data-cy="input-search-notes-keyword"
    matInput
    hidden
  />
</mat-form-field>
<div class="mat-chip-list">
  <mat-chip-set>
    <mat-chip
      (removed)="removeSearchPhrase($event, chip)"
      data-cy="notes-keyword-search-chip"
      *ngFor="let chip of (activeNotesFilters$ | async)?.searchPhrases"
    >
      {{chip | mojoMentionName}}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-set>
</div>
